import getUserAgent from 'functions/getUserAgent';

// Takes everything in the first parenthesis after the semicolon:
//   'CPU OS 11_0 like Mac OS X' <-- 'Mozilla/5.0 (iPad; CPU OS 11_0 like Mac OS X) AppleWebKit/604.1.34 (KHTML, like Gecko) Version/11.0 Mobile/15A5341f Safari/604.1'
//   'CPU iPhone OS 10_3_1 like Mac OS X' <-- 'Mozilla/5.0 (iPhone; CPU iPhone OS 10_3_1 like Mac OS X) AppleWebKit/603.1.30 (KHTML, like Gecko) Version/10.0 Mobile/14E304 Safari/602.1'
//   'Android 10' <-- 'Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Mobile Safari/537.36'

function getOsVersion() {
  try {
    const userAgent = getUserAgent();

    if (!userAgent) return null;

    const matchs = userAgent.match(/\([^()]+\)/);

    if (!matchs?.length) return null;

    return matchs[0].replace(')', '').split(';')?.[1]?.trim();
  } catch (e) {
    return null;
  }
}

export default getOsVersion;
